import { Badge, Button, Grid } from "@mui/material";
import DrawerCM from "components/shared/Drawer";
import React from "react";
import { Fragment } from "react";
import { useState } from "react";
import {
  ButtonContainer,
  StyledDataText,
  StyledDataTitle,
  StyledMessageStatusTitle,
  StyledStack,
} from "./Messages.style";
import MailIcon from "@mui/icons-material/Mail";
import { useCallback } from "react";
import useHttp from "hooks/use-http";
import { getTeacherMessagesRequest } from "api/requests";
import { useEffect } from "react";
import PaginationCM from "components/shared/Pagination";
import LoadingCM from "components/shared/Loading";
import { useNavigate } from "react-router-dom";

// temp data
const FilterBtnValues = {
  all: null,
  isSeen: 1,
  unSeen: 0,
};

export default function Messages() {
  const navigate = useNavigate();

  const [messagesData, setMessagesData] = useState({
    data: [{ content: "اطلاعاتی یافت نشد" }],
    unSeenCount: 0,
    count: 0,
  });

  const [FilterBtn, setFilterBtn] = useState("all");

  // paginition state
  const [page, setPage] = useState(1);

  const { loading, request, setLoading } = useHttp(false);

  const getMessages = useCallback(
    async (filter = true) => {
      setLoading(true);
      const query = {
        skip: (page - 1) * 6,
        limit: 6,
        is_seen: FilterBtnValues[FilterBtn],
      };

      const res = await request({
        url: getTeacherMessagesRequest,
        values: filter ? query : { skip: 0, limit: 6 },
      });
      if (!res?.count || !res?.data.length) {
        return setMessagesData({
          data: [{ content: "اطلاعاتی یافت نشد" }],
          unSeenCount: 0,
          count: 0,
        });
      } else {
        const transformedData = res.data.map((item) => ({
          id: item.id,
          title: item.title,
          sender_type: item.added_by_type === "teacher" ? "مدرس" : "مدیر",
          status: item.is_seen,
          date: item?.created_at?.string ?? "ثبت نشده",
        }));

        setMessagesData({
          data: transformedData,
          unSeenCount: transformedData.filter((item) => !item.status).length,
          count: res.count,
        });
      }
      setLoading(false);
    },
    [FilterBtn, page]
  );

  useEffect(() => {
    getMessages();
  }, [getMessages]);

  return (
    <DrawerCM title="پیام های دریافت شده" $styledHeader>
      {loading ? (
        <LoadingCM />
      ) : (
        <>
          <StyledStack>
            <Grid container>
              <Grid item md={2} sm={4} xs={12}>
                <ButtonContainer>
                  <Button
                    fullWidth
                    variant={FilterBtn === "all" ? "outlined" : "contained"}
                    onClick={() => setFilterBtn("all")}
                  >
                    همه
                  </Button>
                </ButtonContainer>
              </Grid>
              <Grid item md={2} sm={4} xs={12}>
                <ButtonContainer>
                  <Button
                    fullWidth
                    variant={FilterBtn === "isSeen" ? "outlined" : "contained"}
                    onClick={() => setFilterBtn("isSeen")}
                  >
                    خوانده شده
                  </Button>
                </ButtonContainer>
              </Grid>
              <Grid item md={2} sm={4} xs={12}>
                <ButtonContainer>
                  <Button
                    fullWidth
                    variant={FilterBtn === "unSeen" ? "outlined" : "contained"}
                    onClick={() => setFilterBtn("unSeen")}
                  >
                    خوانده نشده
                  </Button>
                </ButtonContainer>
              </Grid>
            </Grid>
          </StyledStack>
          <Grid container>
            {messagesData.count ? (
              <Fragment>
                {messagesData?.unSeenCount ? (
                  <StyledMessageStatusTitle>
                    تعداد پیام های خوانده نشده
                    <Badge
                      sx={{ marginLeft: 1 }}
                      badgeContent={messagesData.unSeenCount}
                      color="error"
                    >
                      <MailIcon color="action" />
                    </Badge>
                  </StyledMessageStatusTitle>
                ) : null}
                {messagesData?.data?.map((item) => (
                  <Grid item md={4} xs={12} key={item.id} p={2}>
                    <StyledStack>
                      <StyledDataTitle>
                        عنوان پیام :
                        <StyledDataText variant="span">
                          {" "}
                          {item.title}
                        </StyledDataText>
                      </StyledDataTitle>
                      <StyledDataTitle>
                        توسط :
                        <StyledDataText variant="span">
                          {" "}
                          {item.sender_type}
                        </StyledDataText>
                      </StyledDataTitle>
                      <StyledDataTitle>
                        وضعیت :
                        <StyledDataText variant="span">
                          {" "}
                          {item.status ? "خوانده شده" : "خوانده نشده"}
                        </StyledDataText>
                      </StyledDataTitle>
                      <StyledDataTitle>
                        تاریخ :
                        <StyledDataText variant="span">
                          {" "}
                          {item.date}
                        </StyledDataText>
                      </StyledDataTitle>
                      <ButtonContainer>
                        <Button
                          fullWidth
                          variant="contained"
                          onClick={() =>
                            navigate("/teacher_messages/" + item.id)
                          }
                        >
                          مشاهده پیام
                        </Button>
                      </ButtonContainer>
                    </StyledStack>
                  </Grid>
                ))}
              </Fragment>
            ) : null}
          </Grid>
        </>
      )}
      {messagesData.data.length < 1 ? (
        ""
      ) : (
        <PaginationCM
          handleChange={(_, val) => setPage(val)}
          page={page}
          limit={6}
          count={messagesData.count}
        />
      )}
    </DrawerCM>
  );
}
